import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';

export default function AdvanceSettings({ children, attributes,setAttributes,clientId }) {
  
    const { mergedStyles, handleMouseEnter, handleMouseLeave,responsiveClasses, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);

    let datealignmentHorizontal = 'center';
    let datealignmentVertical = 'center';
    let datealignmentTabletHorizontal = 'center';
    let datealignmentTabletVertical = 'center';
    let datealignmentMobileHorizontal = 'center';
    let datealignmentMobileVertical = 'center';

    if (attributes.datealignment) {
        let [horizontal, vertical] = attributes.datealignment.split(' ');
        if(horizontal==='bottom'){
            horizontal='end'
        }
        datealignmentHorizontal = horizontal || 'center'; // Set to 'center' if undefined
        datealignmentVertical = vertical || 'center';     // Set to 'center' if undefined
    }

    if (attributes.datealignmenttablet) {
        let [horizontal, vertical] = attributes.datealignmenttablet.split(' ');
        if(horizontal==='bottom'){
            horizontal='end'
        }
        datealignmentTabletHorizontal = horizontal || 'center'; // Set to 'center' if undefined
        datealignmentTabletVertical = vertical || 'center';     // Set to 'center' if undefined
    }

    if (attributes.datealignmentmobile) {
        let [horizontal, vertical] = attributes.datealignmentmobile.split(' ');
        if(horizontal==='bottom'){
            horizontal='end'
        }
        datealignmentMobileHorizontal = horizontal || 'center'; // Set to 'center' if undefined
        datealignmentMobileVertical = vertical || 'center';     // Set to 'center' if undefined
    }

    let dateshow = 'block';
    if(attributes.showdate){
        dateshow ='block';
    } else{
        dateshow = 'none';
    }

    let connectorshow = 'block';
    if(attributes.connector){
        connectorshow ='block';
    } else{
        connectorshow = 'none';
    }

    const style = {
        ...mergedStyles,
        ...(attributes.boxcolor != null && { '--box-color-timeline': attributes.boxcolor }),
        ...(attributes.boxhvrcolor != null && { '--box-hover-color-timeline': attributes.boxhvrcolor ? attributes.boxhvrcolor : attributes.boxcolor }),
        ...(attributes.boxpadding?.top != null && { '--box-padding-box-box': `${attributes.boxpadding.top} ${attributes.boxpadding.left} ${attributes.boxpadding.bottom} ${attributes.boxpadding.right}` }),
        ...(attributes.boxmargin?.top != null && { '--box-margin-box-box': `${attributes.boxmargin.top} ${attributes.boxmargin.left} ${attributes.boxmargin.bottom} ${attributes.boxmargin.right}` }),
        ...(datealignmentHorizontal != null && { '--date-alignment-horizontal': datealignmentHorizontal }),
        ...(datealignmentVertical != null && { '--date-alignment-vertical': datealignmentVertical }),
        ...(datealignmentTabletHorizontal != null && { '--date-alignment-tablet-horizontal': datealignmentTabletHorizontal }),
        ...(datealignmentTabletVertical != null && { '--date-alignment-tablet-vertical': datealignmentTabletVertical }),
        ...(datealignmentMobileHorizontal != null && { '--date-alignment-mobile-horizontal': datealignmentMobileHorizontal }),
        ...(datealignmentMobileVertical != null && { '--date-alignment-mobile-vertical': datealignmentMobileVertical }),
        ...(attributes.datecolor != null && { '--box-date-color': attributes.datecolor }),
        ...(attributes.datehvrcolor != null && { '--box-date-hover-color': attributes.datehvrcolor ? attributes.datehvrcolor : attributes.datecolor }),
        ...(attributes.iconalignment != null && { '--icon-alignment-horizontal': attributes.iconalignment }),
        ...(attributes.iconalignmenttablet != null && { '--icon-alignment-tablet-horizontal': attributes.iconalignmenttablet }),
        ...(attributes.iconalignmentmobile != null && { '--icon-alignment-mobile-horizontal': attributes.iconalignmentmobile }),

        ...(attributes.gapchild != null && { '--gapchild-margin-timeline-child': `${attributes.gapchild?.Desktop}px` }),
        ...(attributes.gapchild != null && { '--gapchild-margin-timeline-child-tablet': `${attributes.gapchild?.Tablet}px` }),
        ...(attributes.gapchild != null && { '--gapchild-margin-timeline-child-mobile': `${attributes.gapchild?.Mobile}px` }),

        ...(attributes.iconcolor != null && { '--icon-backgoruond-color': attributes.iconcolor }),
        ...(attributes.iconhvrcolor != null && { '--icon-hover-backgoruond-color': attributes.iconhvrcolor }),
        ...(attributes.iconiconcolor != null && { '--icon-icon-color-fill-mode': attributes.iconiconcolor }),
        ...(attributes.iconsize != null && { '--icon-size-color-size': `${attributes.iconsize}px` }),
        ...(attributes.iconsizeTablet != null && { '--icon-size-color-size-tablet': `${attributes.iconsizeTablet}px` }),
        ...(attributes.iconsizeMobile != null && { '--icon-size-color-size-mobile': `${attributes.iconsizeMobile}px` }),
        ...(attributes.thickness != null && { '--connector-thickness-width': `${attributes.thickness}px` }),
        ...(attributes.thicknessTablet != null && { '--connector-thickness-width-tablet': `${attributes.thicknessTablet}px` }),
        ...(attributes.thicknessMobile != null && { '--connector-thickness-width-mobile': `${attributes.thicknessMobile}px` }),
        ...(attributes.connectorcolor != null && { '--connector-backgroound-color': attributes.connectorcolor }),
        ...(dateshow != null && { '--date-show-display': dateshow }),
        ...(attributes.datebackgroundcolor != null && { '--date-bnackrgiund-color': attributes.datebackgroundcolor }),
        ...(attributes.datebackgroundcolorhvr != null && { '--date-bnackrgiund-hover-color': attributes.datebackgroundcolorhvr || attributes.datebackgroundcolor }),
        ...(connectorshow != null && { '--connector-display-true-false': connectorshow }),
        '--alignItems-box-main-timeline-child': (attributes.timelinelayout === 'layout-7' || attributes.timelinelayout === 'layout-11')
            ? 'flex-start'
            : (attributes.timelinelayout === 'layout-8' || attributes.timelinelayout === 'layout-12')
            ? 'flex-end'
            : 'center'
        ,
        ...(attributes.touch != null && { '--scroller-width-mode': attributes.touch === 'touch' ? '0px' : attributes.scrollbarwidth }),
        ...(attributes.touch != null && { '--scroller-display-none': attributes.touch === 'touch' ? 'none' : '' }),
        ...(attributes.touch != null && { '--scroller-height-mode': attributes.touch === 'touch' ? '0px' : attributes.scrollbarheight }),
        ...(attributes.thumbbg != null && { '--scroller-color-mode': attributes.thumbbg }),
        ...(attributes.thumbbghvr != null && { '--scroller-hvrcolor-mode': attributes.thumbbghvr ? attributes.thumbbghvr : attributes.thumbbg }),
        ...(attributes.trackbg != null && { '--scroller-track-mode': attributes.trackbg }),
        ...(attributes.touch != null && { '--grabcursor-or-not': attributes.touch !== 'scroll' ? 'grab' : 'default' }),
    };

    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${responsiveClasses}`,
        style: style,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    if(attributes.classNamemain !== blockProps.className) {
        setAttributes({classNamemain: blockProps.className});
    }

    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}

